/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIFeedbackFormFieldRequest } from './APIFeedbackFormFieldRequest';
import {
    APIFeedbackFormFieldRequestFromJSON,
    APIFeedbackFormFieldRequestFromJSONTyped,
    APIFeedbackFormFieldRequestToJSON,
} from './APIFeedbackFormFieldRequest';

/**
 * A collection of serializer extensions, which allow for:
 * 
 * * Blacklisting fields through an "exclude" context variable
 * * Whitelisting fields through an "only" context variable
 * * Expanding related fields through an "expand" context variable
 * * Other helper methods
 * 
 * Blacklisting and whitelisting takes precedence over expanding, and can
 * be used in combination with one another.
 * @export
 * @interface APIPatchedFeedbackFormRequest
 */
export interface APIPatchedFeedbackFormRequest {
    /**
     * 
     * @type {Array<APIFeedbackFormFieldRequest>}
     * @memberof APIPatchedFeedbackFormRequest
     */
    formJson?: Array<APIFeedbackFormFieldRequest>;
    /**
     * 
     * @type {string}
     * @memberof APIPatchedFeedbackFormRequest
     */
    formTitle?: string;
}

/**
 * Check if a given object implements the APIPatchedFeedbackFormRequest interface.
 */
export function instanceOfAPIPatchedFeedbackFormRequest(value: object): value is APIPatchedFeedbackFormRequest {
    return true;
}

export function APIPatchedFeedbackFormRequestFromJSON(json: any): APIPatchedFeedbackFormRequest {
    return APIPatchedFeedbackFormRequestFromJSONTyped(json, false);
}

export function APIPatchedFeedbackFormRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIPatchedFeedbackFormRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'formJson': json['form_json'] == null ? undefined : ((json['form_json'] as Array<any>).map(APIFeedbackFormFieldRequestFromJSON)),
        'formTitle': json['form_title'] == null ? undefined : json['form_title'],
    };
}

export function APIPatchedFeedbackFormRequestToJSON(value?: APIPatchedFeedbackFormRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'form_json': value['formJson'] == null ? undefined : ((value['formJson'] as Array<any>).map(APIFeedbackFormFieldRequestToJSON)),
        'form_title': value['formTitle'],
    };
}

